import { FormattedMessage } from 'react-intl';
import { JSX } from 'react';

import { useStyles } from './benefits-section.styles';
import { ContentWrapper } from '../../../common/content-wrapper';
import { SectionTitle } from '../../../common/section-title';
import { BenefitsList } from './benefits';
import { benefitsItems } from './benefits.items';
import { SectionLabels } from '../../../../constants/common-constants';

export const BenefitsSection = (): JSX.Element => {
  const classes = useStyles();
  const id = SectionLabels.benefits;

  return (
    <section
      className={classes.root}
      data-testid="principles"
      aria-labelledby={id}
    >
      <ContentWrapper externalStyles={classes.content}>
        <SectionTitle
          id={id}
          title="benefits.title"
          isFullWidth
        />
        <h3 className={classes.subtitle}><FormattedMessage id="benefits.subtitle-1" /></h3>
        <BenefitsList items={benefitsItems} />
      </ContentWrapper>
    </section>
  );
};
